import type { SupportedLocale } from "@/i18n";
import { createContext, useContext } from "react";

/**
 * Contexte d'édition de langue du CMS avancé. Les blocs d'aperçu (menu, etc.)
 * lisent la langue courante car la config Puck est un singleton statique.
 *
 * Porte aussi ce qu'il faut aux champs média pour les IMAGES PAR LANGUE
 * (cf. PER_LANGUAGE_IMAGES.md) : la langue par défaut et la BASE média partagée
 * (`blockId → { field: attachmentId }`), pour afficher « hérite / surcharge » et
 * permettre de rétablir l'héritage.
 */
export type PuckEditorLocaleValue = {
  locale: SupportedLocale;
  defaultLocale: SupportedLocale;
  /** Base média partagée (layout neutre) : `blockId → { field: attachmentId }`. */
  mediaBase: Map<string, Record<string, string>>;
};

const PuckEditorLocaleContext = createContext<PuckEditorLocaleValue | null>(null);

export function PuckEditorLocaleProvider({
  value,
  children,
}: {
  value: PuckEditorLocaleValue;
  children: React.ReactNode;
}) {
  return (
    <PuckEditorLocaleContext.Provider value={value}>
      {children}
    </PuckEditorLocaleContext.Provider>
  );
}

/** Langue actuellement éditée (null hors éditeur). */
export function usePuckEditorLocale(): SupportedLocale | null {
  return useContext(PuckEditorLocaleContext)?.locale ?? null;
}

/** Contexte média complet (langue + langue défaut + base). null hors éditeur. */
export function usePuckMediaLocale(): PuckEditorLocaleValue | null {
  return useContext(PuckEditorLocaleContext);
}
